"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function () { return m[k]; } });
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule)
        return mod;
    var result = {};
    if (mod != null)
        for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
                __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
// eslint-disable-next-line @typescript-eslint/no-var-requires
const EventEmitter = require('events');
class Queue extends EventEmitter {
    constructor({ concurrency = 10, cooldown = 0 } = {}) {
        super();
        this.concurrency = concurrency;
        this.cooldown = cooldown;
        this.noCompleted = 0;
        this.noErrors = 0;
        this._running = [];
        this._staging = [];
        this._enqueued = [];
        this.earliestExecution = Date.now();
    }
    executionDelay() {
        const now = Date.now();
        if (this.earliestExecution < now)
            this.earliestExecution = now;
        this.earliestExecution += this.cooldown;
        return this.earliestExecution - now;
    }
    pending() {
        return this._enqueued.length;
    }
    running() {
        return this._running.length;
    }
    staging() {
        return this._staging.length;
    }
    readyToPop() {
        return (this._running.length + this._staging.length) < this.concurrency && this._enqueued.length > 0;
    }
    allDone() {
        return (this._running.length === 0 && this._staging.length === 0 && this._enqueued.length === 0);
    }
    delay(ms) {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }
    pop() {
        if (this.readyToPop()) {
            const fx = this._enqueued.shift();
            this._staging.push(fx);
            this.delay(this.executionDelay())
                .then(() => {
                this._staging.splice(this._staging.indexOf(fx), 1);
                this._running.push(fx);
                // rumor.debug(`${this.running()} running, ${this.staging()} staging and ${this.pending()} pending.`);
            })
                .then(() => {
                let result;
                try {
                    result = fx();
                }
                catch (e) {
                    // rumor.error(e);
                    this.noErrors += 1;
                }
                return Promise.resolve(result);
            })
                .catch(() => {
                // rumor.error(err);
                this.noErrors += 1;
                return Promise.resolve();
            })
                .then(() => {
                this._running.splice(this._running.indexOf(fx), 1);
                this.noCompleted += 1;
            })
                .then(this.pop.bind(this));
        }
        else if (this.allDone()) {
            this.emit('idle', this.noCompleted, this.noErrors);
        }
    }
    push(fx) {
        const tasks = _.isArray(fx) ? fx : [fx];
        tasks.forEach((task) => {
            if (!_.isFunction(task))
                throw new Error('Push only functions that returns promises to the queue.');
            this._enqueued.push(task);
            this.pop();
        });
    }
}
exports.default = Queue;
